export enum AppStateType {
    IssueReport = 'IssueReport',
    DataReset = 'DataReset',
    MigrationIssue = 'MigrationIssue'
}